export enum ActionTypes {
  ADD_CONFIGURATION_TO_LIST = 'ADD_CONFIGURATION_TO_LIST',
  REMOVE_CONFIGURATION_FROM_LIST = 'REMOVE_CONFIGURATION_FROM_LIST',
  SET_USER_IMAGE_FOR_CONFIGURATION = 'SET_USER_IMAGE_FOR_CONFIGURATION',
  SET_CONTEXT_MENU_STATE = 'APP/SET_CONTEXT_MENU_STATE',
  REMOVE_USER_IMAGE_FOR_CONFIGURATION = 'REMOVE_USER_IMAGE_FOR_CONFIGURATION',
  SET_CLICK_TO_ADD_DOOR_HINT_STATE = 'SET_CLICK_TO_ADD_DOOR_HINT_STATE',
}

export interface AddCartConfiguration {
  type: ActionTypes.ADD_CONFIGURATION_TO_LIST;
  configuration: object;
}

export interface RemoveCartConfiguration {
  type: ActionTypes.REMOVE_CONFIGURATION_FROM_LIST;
  configurationCode: string;
}

export interface SetUserImageForConfiguration {
  type: ActionTypes.SET_USER_IMAGE_FOR_CONFIGURATION;
  configurationCode: string;
  file: Blob;
}

export interface SetContextMenuState {
  type: ActionTypes.SET_CONTEXT_MENU_STATE;
  payload: object;
}

export interface RemoveUserImageForConfiguration {
  type: ActionTypes.REMOVE_USER_IMAGE_FOR_CONFIGURATION;
  configurationCode: string;
}

export interface SetClickToAddDoorHintState {
  type: ActionTypes.SET_CLICK_TO_ADD_DOOR_HINT_STATE;
  payload: object;
}

export type AppActions =
  | AddCartConfiguration
  | RemoveCartConfiguration
  | SetUserImageForConfiguration
  | SetContextMenuState
  | RemoveUserImageForConfiguration
  | SetClickToAddDoorHintState;
